import React from 'react'
import classnames from 'classnames'

export default class PostProgramData extends React.Component{
  postProgramIsActive(){
    const reqFrom = window.URLQueryParams()['reqFrom']
    return reqFrom == 'post_program_data'
  }

  render(){
    return(
      <div className={classnames("m-3", "m-md-5", "p-1", "p-md-3", "tab-pane", "fade", "show", "program-data-container", {
        "active": this.postProgramIsActive()
      })} 
      id="profile" 
      role="tabpanel" 
      aria-labelledby="profile-tab">
        { this.props.children }
      </div>
    )
  }
}